var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOff)?_c('div',{staticClass:"banner-header w-100 h--19 h-xl--25 transition",style:(_vm.banner_header_background)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }